<template>
  <div>
    <div class="text-sm-right mb-3">
      <v-btn
        v-show="(selected.length ? true : false)"
        color="default"
        dark
        class="mb-2 mr-2"
        @click="deleteMultipleItem"
      >
        Xóa tất cả
      </v-btn>
    </div>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="zaloContactList"
      :single-select="singleSelect"
      item-key="id"
      class="table-layout pa-5"
      hide-default-footer
    >
      <template v-slot:top />
      <template v-slot:no-data>
        <common-no-result />
      </template>

      <template v-slot:item.avatar="{item}">
        <div>
          <v-img
            v-if="item.avatar"
            :lazy-src="item.avatar"
            max-width="80"
            :src="item.avatar"
          ></v-img>
        </div>
      </template>

      <template v-slot:item.status="{item}">
        <div style="display:flex">
          <span v-if="item.status === 1">Đã khớp thông tin</span>
          <span v-if="item.status === 0">Chưa khớp thông tin</span>
          <span v-if="item.status === 3">Có SĐT chưa khớp</span>
          <v-icon
            v-if="item.status === 1 && item.contactId !== null"
            color="success"
            style="font-size: 16px; margin-left: 6px;"
          >
            mdi-check-circle
          </v-icon>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2 ml-2" @click="editZaloContact(item)" icon small color="primary"  v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
          </template>
          <span>Chỉnh sửa thông tin Zalo</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <zalo-form/>
  </div>
</template>
<script>
  import ZaloForm from './ZaloForm.vue'
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  const ZaloRepository = RepositoryFactory.get('zalo')
  export default {
    components: { ZaloForm },
    props: {
      zaloContactList: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        selectZaloContact: {},
        errorMessage: '',
        headers: [
          {
            text: '',
            value: 'index',
            width: "20px",
            align: 'center'
          },
          { text: 'Avatar', value: 'avatar', align: 'center' },
          { text: 'Tên KH', value: 'name', align: 'center' },
          { text: 'Số điện thoại', value: 'mobile', align: 'center' },
          { text: 'Địa chỉ', value: 'address', align: 'center' },
          { text: 'Thành phố', value: 'city', align: 'center' },
          { text: 'Huyện', value: 'district', align: 'center' },
          { text: 'Khu vực', value: 'ward', align: 'center' },
          { text: 'Trạng thái', value: 'status', align: 'center' },
        ],
        singleSelect: false,
        selected: [],
        productStatusOptions:[],
      }
    },
    created () {
      // if ( this.checkAuthorization('admin-search_read')) {
        this.headers.push({ text: 'Thao tác', value: 'action', align: 'center', sortable: false });
      // }

      // Bus.$emit('zalo-list-filter', this.filterForm)
    },
    methods: {
      async convertStatus (id, status) {
        const statusZaloContact = {
          status,
        }
        this.$swal({
          title: 'Chuyển đổi trạng thái',
          text: 'Bạn có thực sự chắc chắn ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            const loader = this.$loading.show()
            const response = await ZaloRepository.updateStatus(id, statusZaloContact)
            loader.hide()
            if (response.success) {
              this.$swal({
                        title: 'Chuyển đổi thành công !',
                        confirmButtonText: 'Đồng ý',
                      },
              ).then(() => {
                Bus.$emit('zalo-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
          }
        })
      },
      addNewZalo () {
        this.selectZaloContact = {}
        Bus.$emit('zalo-show-form', this.selectZaloContact)
      },
      editZaloContact (zaloItem) {
        this.selectZaloContact = zaloItem
        Bus.$emit('zalo-show-form', this.selectZaloContact)
      },
      async deleteMultipleItem () {
        this.$swal({
          title: 'Xóa toàn bộ kho',
          text: 'Bạn có thực sự muốn xoá các kho này?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            const loader = this.$loading.show()
            const response = await ZaloRepository.deleteManyItems(this.selected.map(s => s.id))
            loader.hide()
            if (response.success) {
              this.selected = []
              this.$swal({
                        title: 'Xoá thành công !',
                        confirmButtonText: 'Đồng ý',
                      },
              ).then(() => {
                Bus.$emit('zalo-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(response, 'message', ''),
              })
            }
          }
        })
      },
    }
  }
</script>
